import styled from "styled-components";
import * as UscCashPrice from "../../price/UscCashPrice.styles";

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    justify-content: center;
    margin-block-start: calc(var(--spacing-3) / 2);
    padding: calc(var(--spacing-3) / 2) 0;
    border-top: 1px solid var(--color-grey-7);

    ${UscCashPrice.Cash} {
        font-size: 1.3rem;
        line-height: 2rem;
    }
`;

export const Prices = styled.div`
    display: flex;
    flex-direction: column;
    align-self: stretch;
    row-gap: var(--spacing-1);

    & div {
        display: flex;
        align-items: center;
        align-self: stretch;
        justify-content: space-between;
    }
`;
